import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 36,
  height: 36,
}

const penthouseApartment = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 36.5 36.5'
  >
    <g fill={color}>
      <path
        d='M187.733,260.258a.609.609,0,0,0,.608.608h2.433a.609.609,0,0,0,.608-.608v-3.65a.609.609,0,0,0-.608-.608h-2.433a.609.609,0,0,0-.608.608v3.65Zm1.217-3.042h1.217v2.433H188.95Z'
        transform='translate(-174.35 -237.75)'
      />
      <path
        d='M188.342,158.468h2.433a.609.609,0,0,0,.608-.608v-3.65a.609.609,0,0,0-.608-.608h-2.433a.609.609,0,0,0-.608.608v3.65A.608.608,0,0,0,188.342,158.468Zm.608-3.65h1.217v2.433h-1.217Z'
        transform='translate(-174.351 -142.651)'
      />
      <path
        d='M120.388,11.471,129.2,6.184l8.812,5.287a.608.608,0,0,0,.627-1.043l-8.83-5.3V1.217h3.042V2.433h-1.825a.608.608,0,0,0,0,1.217h2.433a.609.609,0,0,0,.608-.608V.608A.609.609,0,0,0,133.458,0H129.2a.609.609,0,0,0-.608.608V5.131l-8.83,5.3a.608.608,0,0,0,.627,1.043Z'
        transform='translate(-110.95)'
      />
      <path
        d='M54.242,260.868a.609.609,0,0,0,.608-.608v-3.65a.609.609,0,0,0-.608-.608H51.808a.609.609,0,0,0-.608.608v1.217a.608.608,0,0,0,1.217,0v-.608h1.217v3.042A.609.609,0,0,0,54.242,260.868Z'
        transform='translate(-47.55 -237.751)'
      />
      <path
        d='M137.751,197.45V179.808a.608.608,0,0,0-1.217,0V197.45a.608.608,0,0,0,1.217,0Z'
        transform='translate(-126.801 -166.425)'
      />
      <path
        d='M103.008,366.919h20.683a.608.608,0,1,0,0-1.217h-5.475v-6.083h.608a.608.608,0,0,0,0-1.217h-10.95a.608.608,0,1,0,0,1.217h.608V365.7h-5.475a.608.608,0,0,0,0,1.217Zm10.95-3.65a.608.608,0,0,0,0-1.217v-2.433H117V365.7h-3.042Zm-4.258-3.65h3.042v2.433a.608.608,0,1,0,0,1.217V365.7H109.7Z'
        transform='translate(-95.1 -332.852)'
      />
      <path
        d='M412.643,366.933h-2.433a.609.609,0,0,0-.608.608v3.65a.609.609,0,0,0,.608.608h2.433a.609.609,0,0,0,.608-.608v-3.65A.609.609,0,0,0,412.643,366.933Zm-.608,3.65h-1.217V368.15h1.217Z'
        transform='translate(-380.401 -340.775)'
      />
      <path
        d='M412.643,264.533h-2.433a.609.609,0,0,0-.608.608v3.65a.609.609,0,0,0,.608.608h2.433a.609.609,0,0,0,.608-.608v-3.65A.609.609,0,0,0,412.643,264.533Zm-.608,3.65h-1.217V265.75h1.217Z'
        transform='translate(-380.401 -245.675)'
      />
      <path
        d='M94.425,494.933H68.875a.608.608,0,0,0,0,1.217h25.55a.608.608,0,0,0,0-1.217Z'
        transform='translate(-63.4 -459.65)'
      />
      <path
        d='M400.442,187.733a.609.609,0,0,0-.608.608v.608h-6.692a.608.608,0,0,0,0,1.217h6.692v20.075a.608.608,0,0,0,1.217,0v-21.9A.609.609,0,0,0,400.442,187.733Z'
        transform='translate(-364.551 -174.35)'
      />
      <path
        d='M273.067,260.258a.609.609,0,0,0,.608.608h2.433a.609.609,0,0,0,.608-.608v-3.65a.609.609,0,0,0-.608-.608h-2.433a.609.609,0,0,0-.608.608Zm1.217-3.042H275.5v2.433h-1.217Z'
        transform='translate(-253.6 -237.75)'
      />
      <path
        d='M6.083,315.108c0-.079-.035-7.908-3.042-7.908S0,315.029,0,315.108a3.047,3.047,0,0,0,2.433,2.98v3.1a.608.608,0,0,0,1.217,0v-3.1A3.047,3.047,0,0,0,6.083,315.108Zm-3.042,1.825a1.827,1.827,0,0,1-1.825-1.825c0-3.031.814-6.692,1.825-6.692s1.825,3.661,1.825,6.692A1.827,1.827,0,0,1,3.042,316.933Z'
        transform='translate(0 -285.3)'
      />
      <path
        d='M359.618,189.525v-18.25a.608.608,0,1,0-1.217,0v18.25a.608.608,0,0,0,1.217,0Z'
        transform='translate(-332.851 -158.5)'
      />
      <path
        d='M273.675,158.468h2.433a.609.609,0,0,0,.608-.608v-3.65a.609.609,0,0,0-.608-.608h-2.433a.609.609,0,0,0-.608.608v3.65A.609.609,0,0,0,273.675,158.468Zm.608-3.65H275.5v2.433h-1.217Z'
        transform='translate(-253.6 -142.651)'
      />
      <path
        d='M.608,195.643a.609.609,0,0,0,.608-.608v-4.867H7.908a.608.608,0,1,0,0-1.217H1.217v-.608a.608.608,0,0,0-1.217,0v6.692A.609.609,0,0,0,.608,195.643Z'
        transform='translate(0 -174.352)'
      />
    </g>
  </svg>
)

export default penthouseApartment
